(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["images-with-text-scrolling"] && !Shopify.designMode) return;
  try {
    

// get all elements with the 'image-scrolling-button' class
var buttons = document.getElementsByClassName('image-scrolling-button');

// loop through all buttons
for(var i = 0; i < buttons.length; i++) {

  // add an 'onclick' event listener to each button
  buttons[i].addEventListener('click', function() {
        
      // get the parent 'panel-expand' of the clicked button
      var parent = this.closest('.panel-expand');
      
      // get the 'images-scrolling__content-wrapper' within the same parent
      var contentWrapper = parent.querySelector('.images-scrolling__content-wrapper');
      
      // check if the 'contentWrapper' has the 'reveal' class
      if(contentWrapper.classList.contains('reveal')) {
          // if it has, remove the 'reveal' class from both the contentWrapper and the button itself
          contentWrapper.classList.remove('reveal');
          this.classList.remove('close'); // remove from the button

      } else {
          // if it doesn't, add the 'reveal' class to both the contentWrapper and the button itself
          contentWrapper.classList.add('reveal');
          this.classList.add('close'); // add to the button
      }
  });
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    

// get all elements with the 'image-scrolling-button' class
var buttons = document.getElementsByClassName('image-scrolling-button');

// loop through all buttons
for(var i = 0; i < buttons.length; i++) {

  // add an 'onclick' event listener to each button
  buttons[i].addEventListener('click', function() {
        
      // get the parent 'panel-expand' of the clicked button
      var parent = this.closest('.richtext-expand');
      
      // get the 'images-scrolling__content-wrapper' within the same parent
      var contentWrapper = parent.querySelector('.images-scrolling__content-wrapper');
      
      // check if the 'contentWrapper' has the 'reveal' class
      if(contentWrapper.classList.contains('reveal')) {
          // if it has, remove the 'reveal' class from both the contentWrapper and the button itself
          contentWrapper.classList.remove('reveal');
          this.classList.remove('close'); // remove from the button

      } else {
          // if it doesn't, add the 'reveal' class to both the contentWrapper and the button itself
          contentWrapper.classList.add('reveal');
          this.classList.add('close'); // add to the button
      }
  });
}

  

  } catch(e) { console.error(e); }
})();
})();
